import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import ContractsContext from "./contractsContext";
import {showSignaturePad} from "../../../actions/contractsActions";

/**
 * we need to adjust it because react-pdf gives incorrect positions, gladly we have chatGPT
 **/
function adjustPosition(value) {
  const a = 8.87e-7;
  const b = 1.123;
  // const c = -18.56;
  const c = 1.44;

  return a * Math.pow(value, 2) + b * value + c;
}


const getReceiptSignStyles = (receiptLayout, currentPage) => {
  let styles = {
    position: "absolute",
    left: "50%",
    transform: "translateX(188pt)",
    top: 0
  };
  if (!receiptLayout || !receiptLayout.children || !receiptLayout.children[currentPage] || !receiptLayout.children[currentPage].children) {
    return styles
  }
  const currentChildren = receiptLayout.children[currentPage].children;
  currentChildren.forEach((view) => {
    if (view.children && view.origin && view.children && view.children.length === 3) {
      view.children.forEach((childView) => {
        if (childView.props && childView.origin && childView.props.isSignField) { // PrintDocumentSignature
          styles.top = adjustPosition(view.origin.top) + "pt";
        }
      })
    }
  })
  // temp1.children[0].children.find(view => view.children.some(childView => childView.type === "VIEW" && childView.children && childView.children[0] && childView.children[0].type === "TEXT" && childView.children[0].children[0].value === '(Signature)'))
  return styles;
}

const ReceiptSign = (props) => {

  const {receiptSignature, showSignaturePad, fabricatorData} = props;
  const {receiptLayout, globalContractPage} = useContext(ContractsContext);
  const styles = getReceiptSignStyles(receiptLayout, globalContractPage - 1);


  const onClick = () => {
    showSignaturePad(true, {isReceiptSign: true})
  }

  if (receiptSignature) {
    styles.backgroundImage = "url(" + receiptSignature + ")";
    return (
      <div className="contract-body-indicator contract-body-indicator-signed-image contract-body-indicator-signed-image--receipt"
           style={styles}
           onClick={onClick}>
      </div>
    )
  }

  return (
    <div className={"contract-body-indicator contract-body-indicator-signature"
      + (fabricatorData.receiptSettings && fabricatorData.receiptSettings.signIsRequired
        ? ' contract-body__custom-field-required' : "")}
         style={styles}
         onClick={onClick}>
      <FormattedMessage id="contractSign.signHere"/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {receiptSignature} = store.printState;
  return {
    receiptSignature,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  showSignaturePad,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptSign)
